<div class="flex h-screen flex-col bg-slate-50 font-sans text-slate-800">
  <!-- ===== ヘッダー（上部固定） ===== -->
  <header
    class="z-20 flex h-16 shrink-0 items-center justify-between border-b border-slate-200 bg-white px-4 shadow-sm"
  >
    <div class="flex items-center gap-4">
      <!-- ハンバーガー（サイドメニュー開閉） -->
      <button
        type="button"
        (click)="toggleSidebar()"
        class="rounded-full p-2 text-slate-600 transition-colors hover:bg-slate-100"
        aria-label="メニュー開閉"
      >
        <lucide-icon name="menu" [size]="24"></lucide-icon>
      </button>
      <!-- サービスロゴ -->
      <a
        routerLink="/"
        class="flex items-center gap-2 text-xl font-bold"
      >
        <lucide-icon name="shield-check" class="text-brand-blue" [size]="28"></lucide-icon>
        <span>
          <span class="text-brand-blue">仮）</span><span class="text-brand-navy">検</span><span class="text-brand-blue">太郎</span>
        </span>
      </a>
    </div>

    <div class="flex items-center gap-6">
      <!-- ユーザー情報 -->
      <div
        class="hidden items-center gap-2 border-r border-slate-200 pr-6 text-sm text-slate-600 md:flex"
      >
        <lucide-icon name="building-2" class="text-slate-400" [size]="16"></lucide-icon>
        <span>A社 商品管理部</span>
        <lucide-icon name="user-circle" class="ml-2 text-slate-400" [size]="20"></lucide-icon>
        <span class="font-medium">担当者 様</span>
      </div>
      <!-- ログアウト -->
      <button
        type="button"
        (click)="logout()"
        class="flex items-center gap-2 rounded-md px-3 py-2 text-sm font-medium text-slate-600 transition-all hover:bg-red-50 hover:text-red-600"
      >
        <lucide-icon name="log-out" [size]="18"></lucide-icon>
        <span>ログアウト</span>
      </button>
    </div>
  </header>

  <!-- ===== ボディ ===== -->
  <div class="relative flex flex-1 overflow-hidden">
    <!-- サイドメニュー（せり出し式：コンテンツを押し出す） -->
    <aside
      class="z-10 shrink-0 overflow-hidden border-r border-slate-800 bg-brand-navy text-slate-300 shadow-inner transition-all duration-300 ease-in-out"
      [class.w-64]="isSidebarOpen()"
      [class.w-0]="!isSidebarOpen()"
    >
      <div class="flex h-full w-64 flex-col overflow-y-auto py-6">
        @for (group of menuGroups(); track group.group) {
          <div class="mb-6">
            <div
              class="mb-2 px-6 text-xs font-bold uppercase tracking-wider text-slate-500"
            >
              {{ group.group }}
            </div>
            <nav class="flex flex-col gap-1 px-3">
              @for (item of group.items; track item.link) {
                <a
                  [routerLink]="item.link"
                  class="group flex w-full items-center justify-between rounded-lg px-3 py-2.5 transition-all duration-200"
                  [class]="
                    item.isActive
                      ? 'bg-blue-600/20 font-medium text-blue-400'
                      : 'text-slate-400 hover:bg-slate-800 hover:text-slate-100'
                  "
                >
                  <div class="flex items-center gap-3">
                    <span
                      class="transition-colors"
                      [class]="
                        item.isActive
                          ? 'text-blue-400'
                          : 'text-slate-500 group-hover:text-slate-300'
                      "
                    >
                      <lucide-icon [name]="item.icon" [size]="20"></lucide-icon>
                    </span>
                    <span class="text-sm">{{ item.label }}</span>
                  </div>
                  @if (item.showChevron) {
                    <lucide-icon name="chevron-right" class="text-blue-500" [size]="16"></lucide-icon>
                  }
                </a>
              }
            </nav>
          </div>
        }
      </div>
    </aside>

    <!-- メインコンテンツ -->
    <main class="flex-1 overflow-y-auto overflow-x-hidden p-6 md:p-8">
      <router-outlet />
    </main>
  </div>
</div>
